export const CASES = {
    UPDATE_PRODUCT_GATE: 'UPDATE_PRODUCT_GATE',
    UPDATE_PRODUCT_GATE_FORM: 'UPDATE_PRODUCT_GATE_FORM',
    CLEAR_PRODUCT_GATE: 'CLEAR_PRODUCT_GATE',
};
